import "react-toastify/dist/ReactToastify.css";

import { format } from "date-fns";
import { useCallback, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { v4 } from "uuid";
import * as Yup from "yup";
import {
  ContainerImages,
  ContainerTextArea, Label,
} from "./styles";
import SelectForm from "../../SelectForm/SelectForm";
import InputForm from "../../InputForm/InputForm";
import CustomDatePicker from "../../CustomDatePicker";
import TimePicker from "../../TimePicker/TimePicker";
import TextAreaForm from "../../TextAreaForm";
import ImageSelectRender from "../ImageSelectRender";
import Button from "../../Buttons/Button";
import {convertMinutesFromMidnightToTimeFormat} from "../../../utils/time";
import api from "../../../services/api";
import chevronLeft from "../../../assets/images/icons/chevron-left.svg"
import TopNav from "../../TopNav/TopNav";
import SideBar from "../../SideBar/SideBar";
import RoundedToggleButton from "../../ToggleButton";
import {debounce} from "@mui/material";

export default function NewOffer() {
  const navigate = useNavigate();

  const [subject, setSubject] = useState("");
  const [approvedBy, setApprovedBy] = useState("");

  const [offerImages, setOfferImages] = useState([]);
  const [description, setDescription] = useState("");
  // const [totalOffers, setTotalOffers] = useState("");
  const [expirationDate, setExpirationDate] = useState(null);
  const [expirationTime, setExpirationTime] = useState(null);
  const [isVip, setIsVip] = useState(false);

  const [memberTypeOptions] = useState([
    { label: 'Everyone', value: 'Everyone' },
    { label: 'Male', value: 'Male' },
    { label: 'Female', value: 'Female' }
  ]);
  const [memberType, setMemberType] = useState(memberTypeOptions[0].value);

  const [listVenues, setListVenues] = useState([]);
  const [selectedVenues, setSelectedVenues] = useState(null);

  const [loading, setLoading] = useState(false);
  const [loadingVenues, setLoadingVenues] = useState(true);

  const [errors, setErrors] = useState({});

  const lastImageId = useRef('');
  const [venueSearch, setVenueSearch] = useState("");

  const fetchVenues = useCallback(
      debounce(async (searchTerm) => {
        setLoadingVenues(true);
        try {
          const response = await api.get(`/venue-owners/venues`, {
            params: {
              search: searchTerm, // backend should filter by name
              records: 20,
              page: 0,
            },
          });
          setListVenues(response?.data?.data || []);
        } catch (error) {
          console.log(`venues search failed:`, error);
        } finally {
          setLoadingVenues(false);
        }
      }, 500), // debounce 500ms
      []
  );

  // 🔄 Trigger API when search changes
  useEffect(() => {
    fetchVenues(venueSearch);
  }, [venueSearch, fetchVenues]);

  const optionsVenus = loadingVenues
      ? []
      : listVenues.map((venue) => ({
        value: venue?._id,
        label: venue?.name,
      }));

  const handleCategoryVenues = (selectedOptions) => {
    setSelectedVenues(selectedOptions);
  };

  const handleImageAdd = useCallback((event) => {
    const file = event.target.files?.[0];

    if (!file) {
      return;
    }

    const mediaUrl = URL.createObjectURL(file);

    if (file) {
      const image = {
        id: v4(),
        file,
        mediaUrl
      };

      setOfferImages([image]);
    }
  }, []);

  const handleImageRemove = useCallback((id) => {
    setOfferImages((oldState) => {
      const updatedState = oldState.filter((img) => !(img.id === id));
      return updatedState;
    });
  }, []);

  const handleMemberTypeChange = (selectedValues) => {
    setMemberType(selectedValues ? selectedValues.value : "");
  };

  const handleChangeDescription = (value) => {
    setDescription(value);
  };

  const handleDateChange = (date) => {
    setExpirationDate(date);
  };
  const handleEndTimeChange = ({ value }) => {
    console.log(value);
    setExpirationTime(value);
  };

  const handleToggle = (checked) => {
    setIsVip(checked);
  };

  const validateFields = useCallback(async (data) => {
    const shape = Yup.object().shape({
      subject: Yup.string().required('Required field.'),
      // memberType: Yup.string().required('Required field.'),
      venue_id: Yup.string().required('Required field.'),
      expirationDate: Yup.string().required('Required field.'),
      expirationTime: Yup.string().required('Required field.'),
      // totalOffers: Yup.string().required('Required field.'),
      description: Yup.string().required('Required field.'),
      approvedBy: Yup.string().required('Required field.'),
      offerImages: Yup.array()
          .min(1, 'Please upload an image')
          .required('Required field.'),
    });

    await shape.validate(data, { abortEarly: false });
  }, []);

  const handleAddNewOffer = async (event) => {
    event.preventDefault();
    try {
      const formattedDate = expirationDate
          ? format(expirationDate, "yyyy-MM-dd")
          : "";
      const formattedTime = (!(expirationTime === null) && typeof expirationTime === 'number')
          ? convertMinutesFromMidnightToTimeFormat(expirationTime)
          : "";

      const newOffer = {
        subject: subject.trim(),
        expirationDate: formattedDate,
        expirationTime: formattedTime,
        venue_id: selectedVenues?.value,
        // totalOffers: totalOffers.trim(),
        // hours: hours.hours,
        description: description.trim(),
        memberType: memberType.trim(),
        approvedBy: approvedBy.trim(),
        offerImages: offerImages,
        isVip: isVip,
      };

      try {
        setLoading(true);

        await validateFields(newOffer);

        if (!offerImages.length) {
          const err = {
            response:{
              data: {
                message: 'Please select an image'
              }
            }
          }
          throw err
        }

        const formData = new FormData();

        for (const key in newOffer) {
          if (newOffer.hasOwnProperty(key)) {
            formData.append(key, newOffer[key]);
          }
        }

        if(offerImages.length){
          formData.append('image', offerImages[0].file);
        }

        await api.post("/offers/create", formData);

        toast.success("Offer Created Successfully.");

        navigate('/offers')

      } catch (error) {
        console.log(error?.response?.data?.error);
        if ( error?.response?.data?.error ) toast.error(`${error.response.data.error}`);

        setLoading(false);
        if (error instanceof Yup.ValidationError) {
          setErrors(
              error.inner.reduce((errorObj, currentError) => {
                return {
                  ...errorObj,
                  [currentError.path]: currentError.message,
                };
              }, {})
          );

          toast('Validation error: check the fields and try again.', { type: 'info' });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
      <main>
        <TopNav/>
        <div className="main-container">
          <SideBar/>
          <article
              style={{width: "100%", display: "flex", justifyContent: "center"}}
          >
            <section className="add-event">
              <div className="d-flex align-items-center gap-3 mb-4">
                <Link to="/offers">
                  <img src={chevronLeft} alt="Back"/>
                </Link>
                <h1 className="page-title mb-0">Create Offer</h1>
              </div>

              <form onSubmit={handleAddNewOffer}>
                <div className="row g-3">
                  <div className="col-sm-6">
                    <SelectForm
                        isLoading={loadingVenues}
                        onChange={handleCategoryVenues}
                        options={optionsVenus}
                        value={selectedVenues}
                        label="Venue"
                        error={errors?.venue_id}
                        onInputChange={(value) => setVenueSearch(value)}
                        isSearchable
                    />
                  </div>

                  <div className="col-sm-6">
                    <InputForm
                        label="Title"
                        id="Name"
                        onChange={(event) => setSubject(event.target.value)}
                        value={subject}
                        placeholder="Offer title"
                        error={errors?.subject}
                    />
                  </div>

                  <div className="col-6 col-sm-3">
                    <CustomDatePicker
                        label="Valid until"
                        selectedDate={expirationDate}
                        onChange={handleDateChange}
                        error={errors?.expirationDate}
                    />
                  </div>

                  <div className="col-6 col-sm-3 align-self-end">
                    <TimePicker onChangeTime={handleEndTimeChange}/>
                  </div>

                  <div className="col-sm-6">
                    <InputForm
                        label="Approved By"
                        id="approved"
                        onChange={(event) => setApprovedBy(event.target.value)}
                        value={approvedBy}
                        placeholder="Approved By"
                        error={errors?.approvedBy}
                    />
                  </div>

                  <div className="col-sm-6">
                    <SelectForm
                        onChange={(selected) => setMemberType(selected?.value)}
                        options={memberTypeOptions}
                        value={memberTypeOptions.find((o) => o.value === memberType) || memberTypeOptions[0]}
                        label="Who can redeem"
                    />
                  </div>

                  <div className="col-12">
                    <ContainerTextArea>
                      <TextAreaForm
                          onChange={handleChangeDescription}
                          value={description}
                          label="Description"
                          placeholder="Description of the offer"
                          error={errors?.description}
                      />
                    </ContainerTextArea>
                  </div>

                  <div className="col-12">
                    <div className="fs-14 fw-bold text-white px-2">Image</div>
                    <div className="pb-2 px-2 fs-13 opacity-75 fst-italic">
                      Note: Only .jpg, .jpeg, .png are allowed
                    </div>

                    <ContainerImages className="d-flex align-items-center gap-3 flex-wrap">
                      {offerImages.map((img) => (
                          <ImageSelectRender
                              key={img.id}
                              onRemove={() => handleImageRemove(img.id)}
                              defaultValue={img.mediaUrl}
                          />
                      ))}

                      {offerImages.length === 0 && (
                          <ImageSelectRender onAdd={handleImageAdd}/>
                      )}
                    </ContainerImages>

                    {errors?.offerImages && (
                        <div className="text-danger fs-13 px-2 mt-1">
                          {errors.offerImages}
                        </div>
                    )}
                  </div>

                  <div className="col-12">
                    <RoundedToggleButton onToggle={handleToggle}/>
                    <Label style={{padding: "20px"}}>
                      Add as a VIP Offer
                    </Label>
                  </div>
                </div>


                <div className="mt-4">
                  <Button
                      children={"Create offer"}
                      primaryBtn
                      iconifyIconName="ic:round-check"
                      showLoading={loading}
                      type="submit"
                  />
                </div>
              </form>
            </section>
          </article>
        </div>
      </main>
  );
};
